module.exports = __webpack_public_path__ + "img/double_pizza.2ad38483.webp";